(() => {
  let bundlePromise;
  const loadViewer = (url) => {
    if (window.RollMyLogoViewer) return Promise.resolve(window.RollMyLogoViewer);
    if (!bundlePromise) {
      bundlePromise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        // Classic scripts work on file:// as well as the Shopify asset origin.
        script.src = url;
        script.async = true;
        script.onload = () => {
          if (window.RollMyLogoViewer) resolve(window.RollMyLogoViewer);
          else reject(new Error('3D bundle did not initialize'));
        };
        script.onerror = () => reject(new Error('3D bundle could not be loaded'));
        document.head.append(script);
      });
    }
    return bundlePromise;
  };
  document.querySelectorAll('[data-rml-viewer]').forEach((host) => {
    const controls = host.querySelectorAll('button, input');
    controls.forEach((control) => { control.disabled = true; });
    let started = false;
    const start = async () => {
      if (started) return;
      started = true;
      try {
        const { mountViewer } = await loadViewer(host.dataset.viewerUrl);
        controls.forEach((control) => { control.disabled = false; });
        mountViewer(host, host.closest('[data-rml-builder]'));
      } catch (error) {
        controls.forEach((control) => { control.disabled = true; });
        host.querySelector('[data-viewer-status]').textContent = '3D unavailable. Your imprint and design controls remain available.';
        console.warn('RollMyLogo 3D preview unavailable', error);
      }
    };
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) { observer.disconnect(); start(); }
      }, { rootMargin: '200px' });
      observer.observe(host);
    } else start();
  });
})();
